import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getTopBanks = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/dashboard/top-banks`);
};

export const useTopBanks = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["top-banks", churchId],
    queryFn: () => getTopBanks({ churchId }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
